<template>
	<div class="offer-item" v-if="showOfferItem">
		<div class="offer-info">
			<div class="offer-name">{{ offer.name }}</div>
			<div class="offer-description">{{ offer.description }}</div>
		</div>
		<BaseButton class="validate-button-wrapper" 
			:classNames="validateButtonClasses()" 
			:title="offerText()" 
			@click="applyOffer"/>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import offersMixin from '@Mixin/offersMixin';
	import menuItemMixin from '@Mixin/menuItemMixin';
	import { mapGetters, mapActions } from 'vuex';
	import { ACCOUNT_CHECKOUT } from '@/stores/defs';
	export default {
		mixins: [offersMixin, menuItemMixin],
		props: {
			offer: {
				type: Object,
				default: {
					name: 'Unknown',
					description: '',
				}
			},
		},
		data() {
			return {
				validateButtonClasses: function() {
					return ['button--modifier', 'choice', 'offer'];
				},
				showOfferItem: true,
			};
		},
		computed: {
			...mapGetters({
				offerFlag: ACCOUNT_CHECKOUT.GET_OFFER_FLAG,
			}),
		},
		methods: {
			...mapActions({
				setOfferFlag: ACCOUNT_CHECKOUT.SET_OFFER_FLAG,
			}),
			applyOffer() {
				// TODO may have to decide what type of offer we clicked
				// item or order, for now just items
				const offer = this.offer;
				if (!this.hasOfferInCart(offer)) {
					const item = offer.items[0]; //only one item for now
					this.setOfferFlag(offer.id);
					const route = this.getItemRoute({
						id: item.asset_id,
					});
					this.$router.push(route);
					return;
				}
				this.applyOfferItem(this.offer);
				this.setOfferFlag('');
				EventBus.$emit('recalculate-order');
			},
			offerText() {
				if (!this.hasOfferInCart(this.offer)) {
					return "Add Item";
				}
				return "Use Offer";
			}
		},
		mounted() {
			const offer = this.offer;
			if (offer.id === this.offerFlag) {
				this.applyOffer();
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.offer-item {
		display: flex;
		position: relative;
		.offer-info {
			margin-left: 1em;
		}
		.offer-name {
			color: $offerTextColor;

			max-width: 66%;

			font-weight: bold;
		}
		.validate-button-wrapper {
			position: absolute;
			right: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/OfferItem.vue